// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   BrainMapPage.responsive.css
   Responsive Stylesheet for Neuro Impact Workspace & Brain Map
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .brain-page-shell {
    width: 100%;
    max-width: 100vw;
    padding: 14px 18px 40px !important;
    overflow-x: hidden;
  }

  .page-header {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 14px !important;
  }

  .page-header-actions {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 10px !important;
    width: 100% !important;
  }

  .page-header-actions .filter-select {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 8px);
    min-width: 140px !important;
    min-height: 40px !important;
  }

  .brain-canvas-card,
  .neuron-impact-card {
    border-radius: 16px !important;
    padding: 20px !important;
  }

  .brain-canvas-wrap,
  .neuron-map-canvas {
    height: 480px !important;
    min-height: 480px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .brain-page-shell {
    padding: 10px 10px 30px !important;
  }

  .page-header {
    padding: 0 4px !important;
    margin-bottom: 14px !important;
  }

  .page-header h1,
  .page-title {
    font-size: 24px !important;
    line-height: 1.15 !important;
  }

  .page-subtitle {
    font-size: 13px !important;
    line-height: 1.5 !important;
  }

  .page-header-actions {
    flex-direction: column !important;
    gap: 8px !important;
  }

  .page-header-actions .filter-select {
    width: 100% !important;
    min-height: 40px !important;
    font-size: 13.5px !important;
  }

  /* Meta Card */
  .brain-page-meta-card {
    padding: 14px !important;
    border-radius: 14px !important;
    margin-bottom: 14px !important;
  }

  .summary-grid.compact-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
  }

  .summary-item {
    padding: 10px !important;
    border-radius: 10px !important;
  }

  .summary-item strong {
    font-size: 14px !important;
  }

  /* Canvas viewer */
  .brain-canvas-card,
  .neuron-impact-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .brain-canvas-wrap,
  .neuron-map-canvas {
    height: 360px !important;
    min-height: 360px !important;
    touch-action: pan-y !important;
  }

  .neuron-map-regions {
    grid-template-columns: 1fr !important;
    gap: 10px !important;
    margin-top: 14px !important;
  }

  .neuron-region-item {
    padding: 12px !important;
    border-radius: 12px !important;
  }

  .brain-source-card {
    padding: 14px !important;
    border-radius: 14px !important;
    margin-top: 14px !important;
  }

  .brain-source-card h3 {
    font-size: 16px !important;
  }

  .brain-source-card p {
    font-size: 12.5px !important;
    line-height: 1.5 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BrainMapPage.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;IACjC,kCAAkC;IAClC,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,YAAwC;IAAxC,cAAwC;IAAxC,+BAAwC;IACxC,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;;IAEE,8BAA8B;IAC9B,wBAAwB;EAC1B;;EAEA;;IAEE,wBAAwB;IACxB,4BAA4B;EAC9B;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA,cAAc;EACd;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,2DAA2D;IAC3D,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,kBAAkB;EAClB;;IAEE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;;IAEE,wBAAwB;IACxB,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF","sourcesContent":["/* ==========================================================================\n   BrainMapPage.responsive.css\n   Responsive Stylesheet for Neuro Impact Workspace & Brain Map\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .brain-page-shell {\n    width: 100%;\n    max-width: 100vw;\n    padding: 14px 18px 40px !important;\n    overflow-x: hidden;\n  }\n\n  .page-header {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 14px !important;\n  }\n\n  .page-header-actions {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    gap: 10px !important;\n    width: 100% !important;\n  }\n\n  .page-header-actions .filter-select {\n    flex: 1 1 calc(33.333% - 8px) !important;\n    min-width: 140px !important;\n    min-height: 40px !important;\n  }\n\n  .brain-canvas-card,\n  .neuron-impact-card {\n    border-radius: 16px !important;\n    padding: 20px !important;\n  }\n\n  .brain-canvas-wrap,\n  .neuron-map-canvas {\n    height: 480px !important;\n    min-height: 480px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .brain-page-shell {\n    padding: 10px 10px 30px !important;\n  }\n\n  .page-header {\n    padding: 0 4px !important;\n    margin-bottom: 14px !important;\n  }\n\n  .page-header h1,\n  .page-title {\n    font-size: 24px !important;\n    line-height: 1.15 !important;\n  }\n\n  .page-subtitle {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n  }\n\n  .page-header-actions {\n    flex-direction: column !important;\n    gap: 8px !important;\n  }\n\n  .page-header-actions .filter-select {\n    width: 100% !important;\n    min-height: 40px !important;\n    font-size: 13.5px !important;\n  }\n\n  /* Meta Card */\n  .brain-page-meta-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n    margin-bottom: 14px !important;\n  }\n\n  .summary-grid.compact-summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 8px !important;\n  }\n\n  .summary-item {\n    padding: 10px !important;\n    border-radius: 10px !important;\n  }\n\n  .summary-item strong {\n    font-size: 14px !important;\n  }\n\n  /* Canvas viewer */\n  .brain-canvas-card,\n  .neuron-impact-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .brain-canvas-wrap,\n  .neuron-map-canvas {\n    height: 360px !important;\n    min-height: 360px !important;\n    touch-action: pan-y !important;\n  }\n\n  .neuron-map-regions {\n    grid-template-columns: 1fr !important;\n    gap: 10px !important;\n    margin-top: 14px !important;\n  }\n\n  .neuron-region-item {\n    padding: 12px !important;\n    border-radius: 12px !important;\n  }\n\n  .brain-source-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n    margin-top: 14px !important;\n  }\n\n  .brain-source-card h3 {\n    font-size: 16px !important;\n  }\n\n  .brain-source-card p {\n    font-size: 12.5px !important;\n    line-height: 1.5 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
